<template>
  <div>
    <header-slot></header-slot>
    <b-row>
      <!-- <b-col md="6" class="mt-1">
        <Calendar />
      </b-col>
      <b-col md="6" class="mt-1">
        <CardViatic />
      </b-col> -->
    </b-row>
  </div>
</template>

<script>
// import WebSocketService from "@/ws/WebSocketService.js";

export default {
  name: "DriverDashboard",
  data() {
    return {};
  },
  mounted() {
    try {
      // to connect the public channel
      // window.Echo.channel('public').listen('Hello',(e)=>{
      //    console.log('go public');
      //    //code for displaying the serve data
      //    console.log(e); // the data from the server
      // })

      //  // to connect the privatechannel
      //   window.Echo.private('test-channel.5').listen('PrivateTest',(e)=>{
      //      console.log('go private');
      //      //code for displaying the serve data
      //      console.log(e); // the data from the server
      //   })

      // Create an instance of WebSocketService for the public channel
      // const publicWebSocketService = new WebSocketService("monitoring-channel");

      // // Subscribe to the 'Hello' event on the public channel
      // publicWebSocketService.subscribePublic("Hello",
        // async (response) => {
          // console.log("socket: ", response); // the data from the server
        // }
      // );
    } catch (error) {
      console.error(error);
    }
  },
};
</script>